import React, { useState } from 'react';
import { 
  Card, 
  Form, 
  Input, 
  Button, 
  Switch, 
  Select, 
  Space, 
  Typography, 
  Alert,
  Divider,
  Row,
  Col
} from 'antd';
import { 
  SettingOutlined, 
  SaveOutlined, 
  ReloadOutlined,
  DatabaseOutlined,
  SecurityScanOutlined,
  NotificationOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const Settings: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    // 模拟保存设置
    await new Promise(resolve => setTimeout(resolve, 1000));
    setLoading(false);
    setSaved(true);
    
    // 3秒后隐藏保存成功提示
    setTimeout(() => setSaved(false), 3000);
  };

  const handleReset = () => {
    form.resetFields();
  };

  return (
    <div>
      <Title level={2}>系统设置</Title>
      
      {saved && (
        <Alert
          message="设置已保存"
          type="success"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          site_name: '生物信息学计算服务平台',
          site_description: '提供蛋白质分析、抗体设计、序列分析等生物信息学工具',
          enable_tracking: true,
          enable_notifications: true,
          data_retention_days: 90,
          max_file_size: 50,
          api_rate_limit: 100
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Card title="基本设置">
              <Form.Item
                label="网站名称"
                name="site_name"
                rules={[{ required: true, message: '请输入网站名称' }]}
              >
                <Input placeholder="请输入网站名称" />
              </Form.Item>

              <Form.Item
                label="网站描述"
                name="site_description"
              >
                <TextArea 
                  rows={3} 
                  placeholder="请输入网站描述"
                />
              </Form.Item>

              <Form.Item
                label="启用访问追踪"
                name="enable_tracking"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="启用通知"
                name="enable_notifications"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card title="数据设置">
              <Form.Item
                label="数据保留天数"
                name="data_retention_days"
                rules={[{ required: true, message: '请输入数据保留天数' }]}
              >
                <Input type="number" min={1} max={365} />
              </Form.Item>

              <Form.Item
                label="最大文件大小 (MB)"
                name="max_file_size"
                rules={[{ required: true, message: '请输入最大文件大小' }]}
              >
                <Input type="number" min={1} max={500} />
              </Form.Item>

              <Form.Item
                label="API速率限制 (次/分钟)"
                name="api_rate_limit"
                rules={[{ required: true, message: '请输入API速率限制' }]}
              >
                <Input type="number" min={10} max={1000} />
              </Form.Item>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Card title="安全设置">
              <Form.Item
                label="启用HTTPS"
                name="enable_https"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="启用CORS"
                name="enable_cors"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="会话超时时间 (分钟)"
                name="session_timeout"
              >
                <Input type="number" min={5} max={1440} />
              </Form.Item>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Card title="通知设置">
              <Form.Item
                label="邮件通知"
                name="email_notifications"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="系统通知"
                name="system_notifications"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="错误报告"
                name="error_reporting"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>
        </Row>

        <Divider />

        <Space>
          <Button 
            type="primary" 
            htmlType="submit" 
            icon={<SaveOutlined />}
            loading={loading}
          >
            保存设置
          </Button>
          <Button 
            icon={<ReloadOutlined />}
            onClick={handleReset}
          >
            重置
          </Button>
        </Space>
      </Form>
    </div>
  );
};

export default Settings; 